import { ActionReducerMap } from '@ngrx/store';
import * as fromOptly from './optly.reducer';

export interface OptlyState {
  readonly experiments: fromOptly.OptlyState;
}

export const optlyReducers: ActionReducerMap<OptlyState> = {
  experiments: fromOptly.reducer,
};

export const OPTLY_FEATURE = 'optly';
